import React from 'react';
import { Star } from 'lucide-react';
interface RatingProps {
  value: number;
  count?: number;
  size?: 'sm' | 'md';
}
export function Rating({
  value,
  count,
  size = 'sm'
}: RatingProps) {
  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  return <div className="flex items-center gap-1" data-id="element-150">
      <div className="flex items-center" data-id="element-151">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className={`${iconSize} ${star <= Math.round(value) ? 'fill-accent text-accent' : 'fill-gray-200 text-gray-200'}`} data-id="element-152" />)}
      </div>
      {count !== undefined && <span className={`text-gray-500 ${size === 'sm' ? 'text-xs' : 'text-sm'}`} data-id="element-153">
          ({count})
        </span>}
    </div>;
}